export default "__VITE_ASSET__NAPefkEH__"